var GlobalEventListeners = function(gal) {
    var _this = this,
        fireBrochureView = true,
        _notificationAnimPlayed = false,
        _triggerAppPromoPopup = false,
        _notificationPlayed = {},
        pagesArr = [];

        pagesArr[0] = gal.currentState.currentPage;

    _this.slidedPagesCnt = 0;

    function _xmlEvents() {
        $(document).on('click', '.product-zone', function(e) {
            if(typeof viewSettings.isRedesign !== 'undefined' && viewSettings.isRedesign === true){
                fireEvent(window, 'view.xml.product.onclick', $(this));
            }
            
            e.preventDefault();
        });
    }

    function _sendGaEventLastPage() {
        if (fireBrochureView) {
            if (typeof ga !== 'undefined') {
                ga('send', 'event', 'Brochure:view', 'last-page-view');
            }

            fireBrochureView = false;
        }
    }

    function _showNavigationLastPage() {
        if (navigation.navIsOpen() === false) {
            navigation.toggleNav();
        }
    }

    function _buttonEvents() {
        var device = isMobile ? 'mobile' : 'desktop';

        $(document).on('click', '#btn-notification', function(e) {
            if (typeof ga !== 'undefined') {
                ga('send', 'event', 'bell', device, brandName);
            }

            fromNotificationButton = true;
        });

        $(document).on('click', '.view-related .catalog, .related-brochures-page .catalog', function(e) {
            var linkTo = $(this).find('a')[0].href,
                linkFrom = location.href;

            if (typeof ga !== 'undefined') {
                ga('send', 'event', 'related_back_' + device, linkTo, linkFrom);
            }
        });

        $(document).on('click', '#related-content .catalog', function(e) {
            var linkTo = $(this).find('a')[0].href,
                linkFrom = location.href;

            if (typeof ga !== 'undefined') {
                ga('send', 'event', 'related_scroll', linkTo, linkFrom);
            }
        });

        $(document).on('click', '#btn-back', function(e) {
            var linkFrom = location.href;

            if (typeof ga !== 'undefined') {
                ga('send', 'event', 'back_view', device, linkFrom);
            }
        });

        $(document).on('click', '#btn-tags', function(e) {
            var linkFrom = location.href;

            if (typeof ga !== 'undefined') {
                ga('send', 'event', 'products_list', device, linkFrom);
            }
        });

        $(document).on('click', '#btn-pages', function(e) {
            var linkFrom = location.href;

            if (typeof ga !== 'undefined') {
                ga('send', 'event', 'pages_list', device, linkFrom);
            }
        });


        $(document).on('click', '.view-buttons-wrap.next-brochure, #btn-next-brochure', function(e) {
            var linkTo = viewSettings.relatedBrochure.brochure_link,
                linkFrom = location.href;

            if (typeof ga !== 'undefined') {
                ga('send', 'event', 'next_brochure_' + device, linkTo, linkFrom);
            }
        });

        if (isMobile) {
            $(document).on('click', '#close-mobile', function(e) {
                var action = navigation.navIsOpen() ? 'open' : 'close';

                if (typeof ga !== 'undefined') {
                    ga('send', 'event', 'menu_mobile', 'Click ' + action);
                }
            });
        }
    }

    function _additionalPageEvents() {
        $(document).on('click', '.specific-promo-page area, #promo-last-page', function(e) {
            if(typeof viewSettings.isRedesign === 'undefined' || viewSettings.isRedesign === false){
                e.preventDefault();
            }
        });

        window.addEventListener('view.specific.promo.page.onclick', function(event) {
            var device = isMobile ? 'mobile' : 'desktop',
                category = "Inside-Page",
                action = device + '-' + brochureSeoUrl + '-last-page',
                // label = event.customMessage;
                label = 'black-friday-2017', //TODO change this value when this should be used for general purpose
                newWindow;

            event.preventDefault();
            if (typeof ga !== 'undefined') {
                ga('send', 'event', category, action, label);
            }

            if(isMobile){
                setTimeout(function(){
                    window.location.href = event.customMessage;
                }, 10);
            }else{
                newWindow = window.open(event.customMessage, "_blank");
                newWindow.opener = null;
            }
        });

        window.addEventListener('view.app.promo.page.onclick', _openUrlInNewWindow);
        window.addEventListener('view.last.page.banner.onclick', _openUrlInNewWindow);
    }

    function _openUrlInNewWindow(event){
        event.preventDefault();
        var el = event.customMessage,
            ec = $(el).data('ga-category') || '',
            ea = $(el).data('ga-action') || '';

        if(ec && ea){
            ga('send', 'event', ec, ea);
        }

        var newWindow = window.open(el.href, "_blank");
        newWindow.opener = null;
    }

    function _animateBtn(id, animationName){
        if(id in _notificationPlayed == false){
            helpers.toggleBtnAnimation(id, animationName)
            _notificationPlayed[id] = true;
        }
    }

    function _init() {

        if (typeof offerista_tracking !== "undefined" && offerista_tracking && Number(brochureOfferistaId) > 0) {
            // BROCHUREPAGE_VIEW
            var brochurePageTracking = new OfferistaTracking(),
                brochurePageData = brochurePageTracking.data;
                //trackUuid = brochurePageTracking.createUUID();

            brochurePageData.trackings[0].type = "BROCHUREPAGE_VIEW";
            brochurePageData.trackings[0].objectId = Number(brochureOfferistaId);
            //brochurePageData.trackings[0].trackUuid = trackUuid;

            // BROCHURE_CLICK
            var brochureClickTracking = new OfferistaTracking(),
                brochureClickData = brochureClickTracking.data;

            brochureClickData.trackings[0].type = "BROCHURE_CLICK";
            brochureClickData.trackings[0].objectId = Number(brochureOfferistaId);
            brochureClickTracking.sendTracking(brochureClickData);

            // BROCHUREPAGE_DURATION
            var offeristaPageDurationTracking = new OfferistaTracking();
                offeristaPageDurationData = offeristaPageDurationTracking.data,
                lastTwoDatesArr = [],
                lastTwoUUIDsArr = [],
                trackUuid = "",
                durationSeconds = 0,
                durationPageNumber = [];

            offeristaPageDurationData.trackings[0].type = "BROCHUREPAGE_DURATION";
            offeristaPageDurationData.trackings[0].objectId = Number(brochureOfferistaId);
            //offeristaPageDurationData.trackings[0].relatedTrackUuid = trackUuid;
                
            if (typeof gal.gallery.currItem.inx !== "undefined") {
                brochurePageData.trackings[0].brochurePage = gal.gallery.currItem.inx + 1;

                trackUuid = brochurePageTracking.createUUID();
                brochurePageData.trackings[0].trackUuid = trackUuid;

                brochurePageTracking.sendTracking(brochurePageData);

                lastTwoUUIDsArr.push(trackUuid);
                lastTwoDatesArr.push(brochurePageData.trackings[0].createdAt);
                durationPageNumber.push(brochurePageData.trackings[0].brochurePage);
            }

            var pendingBrochureLastPageImpressionsArr = [];

            function genereateImpressionTrackingData() {
                var brochuresLastPageImpressionTracking = new OfferistaTracking();
                var brochuresObjectsArray = [];    
        
                for (i=0; i<pendingBrochureLastPageImpressionsArr.length; i++) {
                    brochuresObjectsArray[i] = (new OfferistaTracking()).data.trackings[0];
                    brochuresObjectsArray[i].type = "BROCHURE_IMPRESSION"
                    brochuresObjectsArray[i].objectId = pendingBrochureLastPageImpressionsArr[i];
                }
                
                brochuresLastPageImpressionTracking.sendTracking({fn: "offeristaTracking", trackings: brochuresObjectsArray});
                pendingBrochureLastPageImpressionsArr = [];
            }
        
            function lastPageRelatedDataTracking() {
                var brochuresLeftSelector = $('#back-cover .catalog'),
                    sliderHeight = $('#back-cover .view-related').height();
        
                $.each(brochuresLeftSelector, function(_, el){
                    if ( $(el).position().top <= sliderHeight && $(el).position().top >= 0 ) {
        
                        var id = Number($(el).attr('data-offerista-id'));
        
                        if ( sentBrochureImpressionsArr.indexOf(id) === -1 ) {
                            sentBrochureImpressionsArr.push(id);
                            pendingBrochureLastPageImpressionsArr.push(id);
                        }
        
                    } 
                    if ( $(el).position().top > sliderHeight ) {
                        return false;
                    }
                });
        
                if ( pendingBrochureLastPageImpressionsArr.length > 0 ) {
                    genereateImpressionTrackingData();
                }
            }
        }

        if (typeof brochure_impression_statistics !== "undefined" && brochure_impression_statistics) {

            var pendingBrochureLastPageImpressionsStatArr = [];

            function sendLastPageImpressionsStat() {
                var device = (isMobile || isTablet) ? 'mobile' : 'desktop';

                function createUUID() {
                    return 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                        return v.toString(16);
                    });
                };

                function setCookie(name, value, days) {
                    var d = new Date;
                    d.setTime(d.getTime() + 24*60*60*1000*days);
                    document.cookie = name + "=" + value + ";path=/;expires=" + d.toUTCString();
                }

                function getCookie(name) {
                    var value = "; " + document.cookie;
                    var parts = value.split("; " + name + "=");
                    if (parts.length === 2) return parts.pop().split(";").shift();
                }

                if (document.cookie.indexOf('uid=') !== -1) {
                    uuid = getCookie('uid');
                } else {
                    uuid = createUUID();
                    setCookie('uid', uuid, 365);
                }

                $.ajax({
                    type: "POST",
                    url: '/ajx/ajax.file.php',
                    contentType: "application/json",
                    data: JSON.stringify({
                        impressions: pendingBrochureLastPageImpressionsStatArr,
                        device: device,
                        userUuid: uuid,
                        fn: "brochureImpressions"
                    }),
                    dataType: 'json',
                    success: function(data){
                        
                    },
                    error: function(err){}
                });
    
                pendingBrochureLastPageImpressionsStatArr = [];
            }
        
            function lastPageRelatedDataTracking() {
                var brochuresLeftSelector = $('#back-cover .catalog'),
                    sliderHeight = $('#back-cover .view-related').height();
        
                $.each(brochuresLeftSelector, function(_, el){
                    if ( $(el).position().top <= sliderHeight && $(el).position().top >= 0 ) {
        
                        var id = Number($(el).attr('data-brochure-id'));
        
                        if ( sentBrochureImpressionsArr.indexOf(id) === -1 ) {
                            sentBrochureImpressionsArr.push(id);
                            pendingBrochureLastPageImpressionsStatArr.push(id);
                        }
        
                    } 
                    if ( $(el).position().top > sliderHeight ) {
                        return false;
                    }
                });
        
                if ( pendingBrochureLastPageImpressionsStatArr.length > 0 ) {
                    sendLastPageImpressionsStat()
                }
            }
        }

        window.addEventListener('view.last.page.show', function(event) {
            _sendGaEventLastPage();
            
            if (typeof offerista_tracking !== "undefined" && offerista_tracking) {
                lastPageRelatedDataTracking();

                if ( typeof brochurePageData.trackings[0].brochurePage !== "undefined" ) {
                    offeristaPageDurationData.trackings[0].brochurePage = brochurePageData.trackings[0].brochurePage;
                
                    durationSeconds = ( new Date() - new Date(brochurePageData.trackings[0].createdAt) ) / 1000;
                    offeristaPageDurationData.trackings[0].duration = Math.ceil(durationSeconds);

                    offeristaPageDurationData.trackings[0].relatedTrackUuid = typeof lastTwoUUIDsArr[1] !== "undefined" ? lastTwoUUIDsArr[1] : lastTwoUUIDsArr[0];
                    
                    if (durationSeconds < 86400) {
                        offeristaPageDurationTracking.sendTracking(offeristaPageDurationData);
                    }
                }

                $("#back-cover .view-related").on('scroll', function(){
                    lastPageRelatedDataTracking();
                });
            }

            if (isMobile) {
                _showNavigationLastPage();
            }
        }, true);

        window.addEventListener('view.pin.onclick', function(event) {
            var pin = event.customMessage.pin,
                label = pin.type === 1 ? 'blue' : 'green',
                action = pin.real_url,
                pageNum = typeof event.customMessage.pageInx !== 'undefined' ? event.customMessage.pageInx : parseInt(event.currentTarget.pageNumber) - 1;

                if(typeof gal.isAdditionalPage !== 'undefined' && gal.isAdditionalPage(pageNum)){
                    (gal.jsonData.type === ViewConsts.xml) ? ga('send', 'event','XML product' ,'inside-page', event.customMessage.pin.real_url) : ga('send', 'event', 'Inside-Page', action);
                }else{
                    ga('send', 'event', 'Pin:' + label, action);
                }
                
                if(typeof goog_report_conversion !== 'undefined' && typeof goog_report_conversion === 'function'){
                    goog_report_conversion(action, true);
                }

                if(typeof fbq !== 'undefined' && typeof fbq === 'function' && typeof FbConversionValue !== 'undefined' && typeof FbContentType !== 'undefined'){
                    fbq('track', 'ViewContent', { 
                        'value': FbConversionValue, 
                        'content_type': FbContentType
                    });
                }
        }, true);

        window.addEventListener('view.onpagechange', function(event) {
            _this.slidedPagesCnt++;
            
            if(isMobile == false){
                _animateBtn('btn-notification', 'tada');
            }
            
            if (typeof offerista_tracking !== "undefined" && offerista_tracking && Number(brochureOfferistaId) > 0) {
                if (typeof gal.gallery.currItem.inx !== "undefined") {
                    brochurePageData.trackings[0].brochurePage = gal.gallery.currItem.inx + 1;
                    brochurePageData.trackings[0].createdAt = (new Date()).toISOString();

                    lastTwoDatesArr.push(brochurePageData.trackings[0].createdAt);
                    lastTwoDatesArr = lastTwoDatesArr.slice(lastTwoDatesArr.length - 2);

                    durationPageNumber.push(brochurePageData.trackings[0].brochurePage);
                    durationPageNumber = durationPageNumber.slice(durationPageNumber.length - 2);

                    trackUuid = brochurePageTracking.createUUID();
                    brochurePageData.trackings[0].trackUuid = trackUuid;
                    lastTwoUUIDsArr.push(trackUuid);
                    lastTwoUUIDsArr = lastTwoUUIDsArr.slice(lastTwoUUIDsArr.length - 2);

                    brochurePageTracking.sendTracking(brochurePageData);

                    if (lastTwoDatesArr.length >= 2 && durationPageNumber[0] !== durationPageNumber[1]) {
                        durationSeconds = ( new Date(lastTwoDatesArr[1]) - new Date(lastTwoDatesArr[0]) ) / 1000;
                        offeristaPageDurationData.trackings[0].duration = Math.ceil(durationSeconds);

                        offeristaPageDurationData.trackings[0].brochurePage = durationPageNumber[0];
                        offeristaPageDurationData.trackings[0].relatedTrackUuid = lastTwoUUIDsArr[0];

                        if (durationSeconds < 86400) {
                            offeristaPageDurationTracking.sendTracking(offeristaPageDurationData);
                        }
                    }
                }
            }

            if(!isMobile && _this.slidedPagesCnt == 1){
                _animateBtn('btn-app-landing', 'tada');
            }

            pagesArr.push(gal.currentState.currentPage);

            var currentUrl = location.origin + location.pathname;
            var urlsWithShowedBanner = sessionStorage.urlsWithShowedBanner ? JSON.parse(sessionStorage.urlsWithShowedBanner) : [];
            
            if((pagesArr[pagesArr.length-1] - pagesArr[0]) === 2) {
                fireEvent(window, 'show-async-banner-css');
            } else if((pagesArr[pagesArr.length-1] - pagesArr[0]) === 1 && !$.trim($('.desktop-async-banner').html()).length && !(urlsWithShowedBanner.indexOf(currentUrl) > -1)) {
                fireEvent(window, 'show-async-banner');
                if(typeof asyncDesktopViewAd !== "undefined") {
                    $(".desktop-async-banner").append(asyncDesktopViewAd.slot);
                }
            }

        }, true);

        _buttonEvents();
        _additionalPageEvents();

        if (gal.jsonData.type === ViewConsts.xml) {
            _xmlEvents();

            window.addEventListener('view.xml.product.onclick', function(event) {
                var el = event.customMessage ? event.customMessage[0] : event.customMessage,
                    action = el.getAttribute('data-real-url'),
                    category = 'XML product',
                    newWindow;

                newWindow = window.open(el.href, "_blank");
                newWindow.opener = null;

                (el.dataset.productType === "1") ? ga('send', 'event', category, 'banner-click', action) : ga('send', 'event', category, action);
                
                if(typeof fbq !== 'undefined' && typeof fbq === 'function' && typeof FbConversionValue !== 'undefined' && typeof FbContentType !== 'undefined'){
                    fbq('track', 'ViewContent', { 
                        'value': FbConversionValue, 
                        'content_type': FbContentType
                    });
                }
                event.preventDefault();
            });
        }

        if (typeof offerista_tracking !== "undefined" && offerista_tracking && Number(brochureOfferistaId) > 0) {
            var brochureClickOutTracking = new OfferistaTracking(),
                brochureClickOutData = brochureClickOutTracking.data;
            
            brochureClickOutData.trackings[0].type = "BROCHUREPAGE_CLICKOUT";
            brochureClickOutData.trackings[0].objectId = Number(brochureOfferistaId);
            
            $(document).on('click', '.slider-pin-zone', function(e){
                brochureClickOutData.trackings[0].target = $(this).attr('data-real-url');
                brochureClickOutData.trackings[0].brochurePage = (gal.gallery.currItem.doublePageSlide === true) ? (gal.gallery.getCurrentIndex() * 2) + 1 : gal.gallery.getCurrentIndex() + 1;

                brochureClickOutTracking.sendTracking(brochureClickOutData); 
            });

            $(window).bind("beforeunload", function() {
                if ( typeof gal.gallery.currItem.inx !== "undefined" ) {
                    offeristaPageDurationData.trackings[0].brochurePage = gal.gallery.currItem.inx + 1;
                
                    durationSeconds = ( new Date() - new Date(brochurePageData.trackings[0].createdAt) ) / 1000;
                    offeristaPageDurationData.trackings[0].duration = Math.ceil(durationSeconds);

                    offeristaPageDurationData.trackings[0].relatedTrackUuid = typeof lastTwoUUIDsArr[1] !== "undefined" ? lastTwoUUIDsArr[1] : lastTwoUUIDsArr[0];
                    
                    if (durationSeconds < 86400) {
                        offeristaPageDurationTracking.sendTracking(offeristaPageDurationData);
                    }
                }
            });    
        }
    }

    _this.init = _init;
    _this.xmlEvents = _xmlEvents;
};
